import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IFinanceUserItem {
  id: string;
  name: string;
  email: string;
  username: string;
  role: string;
  isSelect: boolean;
}

export interface SendToFinancePopupData {
  financeUsers: IFinanceUserItem[];
  defaultRemarks?: string;
}

export interface SendToFinancePopupResult {
  selectedUsers: IFinanceUserItem[];
  remarks: string;
}

@Component({
  selector: 'app-send-to-finance-popup',
  templateUrl: './send-to-finance-popup.component.html',
  styleUrls: ['./send-to-finance-popup.component.scss'],
})
export class SendToFinancePopupComponent implements OnInit {
  users: IFinanceUserItem[] = [];
  form: FormGroup;
  searchTerm = '';

  constructor(
    private dialogRef: MatDialogRef<SendToFinancePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendToFinancePopupData
  ) {}

  ngOnInit(): void {
    this.users = (this.data?.financeUsers || []).map((u) => ({
      ...u,
      isSelect: u.isSelect !== undefined ? u.isSelect : true,
    }));

    this.form = new FormGroup({
      remarks: new FormControl(
        this.data?.defaultRemarks ||
          'Invoice documents have been uploaded. Please review and process the invoice.',
        [Validators.required]
      ),
    });
  }

  get filteredUsers(): IFinanceUserItem[] {
    if (!this.searchTerm.trim()) {
      return this.users;
    }
    const term = this.searchTerm.toLowerCase();
    return this.users.filter(
      (u) =>
        u.name?.toLowerCase().includes(term) ||
        u.email?.toLowerCase().includes(term) ||
        u.username?.toLowerCase().includes(term)
    );
  }

  get isAllSelected(): boolean {
    return this.users.length > 0 && this.users.every((u) => u.isSelect);
  }

  get isSomeSelected(): boolean {
    const selectedCount = this.users.filter((u) => u.isSelect).length;
    return selectedCount > 0 && selectedCount < this.users.length;
  }

  get hasSelectedUsers(): boolean {
    return this.users.some((u) => u.isSelect);
  }

  toggleSelectAll(checked: boolean): void {
    this.users.forEach((u) => (u.isSelect = checked));
  }

  toggleUser(user: IFinanceUserItem): void {
    user.isSelect = !user.isSelect;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    const selectedUsers = this.users.filter((u) => u.isSelect);
    const result: SendToFinancePopupResult = {
      selectedUsers,
      remarks: this.form.get('remarks')?.value?.trim() || '',
    };
    this.dialogRef.close(result);
  }
}
